<template>
  <div class="flex h-full w-full flex-col gap-4 p-2">
    <Header :breadcrumbs="[{ label: 'Impressum' }]"> </Header>

    <div role="main" class="mx-auto flex flex-col">
      <h3 class="mb-1 mt-3 text-xl font-bold">Anbieterkennung</h3>
      <h4 class="font-bold">GDW Nord eG</h4>
      <p>Salzburger Str. 22</p>
      <p>39387 Oschersleben</p>
      <p>Telefon: +49 (0) 39 49 | 9 48 48-0</p>
      <p>E-Mail: info[at]gdw-nord.de</p>
      <h3 class="mb-1 mt-3 text-xl font-bold">Verantwortlich für den Inhalt:</h3>
      <p>Vertretungsberechtigte Person</p>
      <p>Dr. Manfred Duchâteau (Geschäftsführender Vorstand)</p>
      <h3 class="mb-1 mt-3 text-xl font-bold">Vorstand</h3>
      <p>Erik Dietzel</p>
      <p>Dr. Manfred Duchâteau</p>
      <p>Hans-Martin Goeritz</p>
      <p>Eduard Irkha</p>
      <p>Rainer Nelskamp</p>
      <h3 class="mb-1 mt-3 text-xl font-bold">Aufsichtsratsvorsitzender</h3>
      <p>Thomas Stengel</p>
      <h3 class="mb-1 mt-3 text-xl font-bold">Registergericht</h3>
      <p>Amtsgericht Stendal, GnR 2495</p>
      <h3 class="mb-1 mt-3 text-xl font-bold">Umsatzsteuer-ID</h3>
      <p>Umsatzsteuer-Identifikationsnummer gemäß §27 a Umsatzsteuergesetz: DE 174892866</p>
      <h3 class="mb-1 mt-3 text-xl font-bold">Prüfungsverband</h3>
      <p>Zuständiger Prüfungsverband nach § 54 GenG</p>
      <p>Genossenschaftsverband - Verband der Regionen e. V.</p>
      <p>Sitz: Frankfurt am Main</p>
      <h3 class="mb-1 mt-3 text-xl font-bold">Marke</h3>
      <p>
        didab ist eine beim DPMA eingetragene Marke. Eine Nutzung der Marke durch Dritte ist nur noch Genehmigung durch
        die gdw nord möglich.
      </p>
      <h3 class="mb-1 mt-3 text-xl font-bold">Programmierung der Plattform</h3>
      <p>GEPROG GmbH, Kiel</p>
    </div>

    <Footer />
  </div>
</template>
